
// This file is generated. Don't modify it.
import React from 'react'
export default function ExcelIcon (props) {

    const { color } = props
    
    return (
                
        <svg width="1em" height="1em" viewBox="0 0 15 16">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Icon/Documents/Excel" transform="translate(-1.000000, 0.000000)">
                    <g>
                        <g id="word" transform="translate(1.200000, 0.000000)">
                            <path d="M0.614479638,0 C0.31040724,0 0.00633484163,0.3 0.00633484163,0.6 L0.00633484163,15.4 C0.00633484163,15.7 0.31040724,16 0.614479638,16 L13.3855204,16 C13.6895928,16 13.9936652,15.7 13.9936652,15.4 L13.9936652,3.5 L10.4461538,0 L0.614479638,0 Z" id="ExcelIcon-Path" fill={"#5FBB92"}></path>
                            <path d="M10.4461538,0 L10.4461538,2.88 C10.4461538,3.18 10.7502262,3.5 11.0745701,3.5 L13.9936652,3.5 L10.4461538,0 Z" id="ExcelIcon-path" fill={"#BADDCF"}></path>
                        </g>
                        <polygon id="x" fill="#FFFFFF" points="4.875 12 7.26875 8.58125 4.975 5.3625 7.11875 5.3625 8.29375 7.1875 9.53125 5.3625 11.59375 5.3625 9.34375 8.50625 11.8 12 9.64375 12 8.29375 9.94375 6.93125 12"></polygon>
                    </g>
                </g>
            </g>
        </svg>
        
    )
}
